import { render, staticRenderFns } from "./moreProd.vue?vue&type=template&id=24bb7f38&scoped=true&"
import script from "./moreProd.vue?vue&type=script&lang=js&"
export * from "./moreProd.vue?vue&type=script&lang=js&"
import style0 from "./moreProd.vue?vue&type=style&index=0&id=24bb7f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb7f38",
  null
  
)

export default component.exports